var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavAutomations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.58 2.582a.82.82 0 0 1 .405.88l-.82 4.395h4.085c.294 0 .56.184.682.47a.85.85 0 0 1-.115.86l-6.5 8.036a.716.716 0 0 1-.897.195.82.82 0 0 1-.405-.88l.82-4.395H4.75a.75.75 0 0 1-.682-.47.85.85 0 0 1 .115-.86l6.5-8.036a.716.716 0 0 1 .897-.195",
  clipRule: "evenodd"
})));
SvgNavAutomations.displayName = "SvgNavAutomations";
export { SvgNavAutomations as ReactComponent };
export default SvgNavAutomations;